import * as Document from 'containers/desktop/KnowledgeBases/types/Document';
import * as KnowledgeBase from 'containers/desktop/KnowledgeBases/types/KnowledgeBase';
import * as KnowledgeBaseList from 'containers/desktop/KnowledgeBases/types/KnowledgeBaseList';

export type Type = {
	knowledgeBases: KnowledgeBaseList.Type;
	currentKnowledgeBaseId: string | null;
	file: FormData | null;
};

export function create(): Type {
	return {
		knowledgeBases: KnowledgeBaseList.create(),
		currentKnowledgeBaseId: null,
		file: null,
	};
}

export async function initialize(state: Type): Promise<Type> {
	return {
		...state,
		knowledgeBases: await KnowledgeBaseList.initialize(),
	};
}

export function setCurrentKnowledgeBaseId(
	state: Type,
	currentKnowledgeBaseId: string | null
): Type {
	return {
		...state,
		currentKnowledgeBaseId,
	};
}

export async function uploadDocument(state: Type): Promise<Type> {
	if (!state.file) return state;
	const output: KnowledgeBaseList.Type = [];
	for (const knowledgeBase of state.knowledgeBases) {
		if (knowledgeBase.id === state.currentKnowledgeBaseId) {
			output.push(await KnowledgeBase.uploadDocument(knowledgeBase, state.file));
		} else {
			output.push(knowledgeBase);
		}
	}
	return {
		...state,
		knowledgeBases: output,
	};
}

export function createAndSetFile(state: Type, file: File | null): Type {
	if (!file) return state;
	const formData = new FormData();
	formData.append('file', file);
	formData.append('name', file.name);
	formData.append('type', file.type);
	return {
		...state,
		file: formData,
	};
}

export async function deleteDocument(state: Type, document?: Document.Type): Promise<Type> {
	if (!document) return state;
	if (!state.currentKnowledgeBaseId) return state;
	const output: KnowledgeBaseList.Type = [];
	for (const knowledgeBase of state.knowledgeBases) {
		if (knowledgeBase.id === state.currentKnowledgeBaseId) {
			output.push(await KnowledgeBase.deleteDocument(knowledgeBase, document));
		} else {
			output.push(knowledgeBase);
		}
	}
	return {
		...state,
		knowledgeBases: output,
	};
}

export async function parseDocument(state: Type, document?: Document.Type): Promise<Type> {
	if (!document) return state;
	if (!state.currentKnowledgeBaseId) return state;
	const output: KnowledgeBaseList.Type = [];
	for (const knowledgeBase of state.knowledgeBases) {
		if (knowledgeBase.id === state.currentKnowledgeBaseId) {
			output.push(await KnowledgeBase.parseDocument(knowledgeBase, document));
		} else {
			output.push(knowledgeBase);
		}
	}
	return {
		...state,
		knowledgeBases: output,
	};
}

export async function stopParsingDocument(state: Type, document?: Document.Type): Promise<Type> {
	if (!document) return state;
	if (!state.currentKnowledgeBaseId) return state;
	const output: KnowledgeBaseList.Type = [];
	for (const knowledgeBase of state.knowledgeBases) {
		if (knowledgeBase.id === state.currentKnowledgeBaseId) {
			output.push(await KnowledgeBase.stopParsingDocument(knowledgeBase, document));
		} else {
			output.push(knowledgeBase);
		}
	}
	return {
		...state,
		knowledgeBases: output,
	};
}
